import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../../component/Navbar";
import { baseurl } from "../../component/Baseurl";

function VisitorHotelBookingConfirm() {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state || {};
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
  
// ✅ Define queryParams first
const queryParams = new URLSearchParams(location.search);

 
  return (
    <>
      <Navbar />
      <div className="m-0 p-0">
        <section>
          <div className="tourz-search">
            <div className="container">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <div className="invoice-box p-4 border rounded bg-white shadow-sm">
                    <h2 className="text-center mb-4">Hotel Booking Details </h2>

                    {/* Travelers Information */}
                    <h4 className="mb-3">Traveler Details</h4>
                     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default VisitorHotelBookingConfirm;
